import type { SiteConfig, FeatureItem } from '../../../siteContentTypes.ts';
import { TextField, TextAreaField, ImageField, SelectField, ListEditor } from './fields.tsx';
import { ICON_NAMES } from '../../../lib/icons.ts';

export function FeatureConfigSection({
  title,
  data,
  onChange,
}: {
  title: string;
  data: SiteConfig['extrasSection'];
  onChange: (patch: Partial<SiteConfig['extrasSection']>) => void;
}) {
  return (
    <div>
      <h2 style={{ fontSize: 18, fontWeight: 800, marginBottom: 20 }}>{title}</h2>
      <TextField label="Titre" value={data.title} onChange={(v) => onChange({ title: v })} />
      <TextAreaField label="Sous-titre" value={data.subtitle} onChange={(v) => onChange({ subtitle: v })} rows={2} />
      <ImageField label="Image" value={data.image} onChange={(v) => onChange({ image: v })} />
      <TextField label="Texte du CTA" value={data.ctaText} onChange={(v) => onChange({ ctaText: v })} />
      <TextField label="Lien du CTA" value={data.ctaUrl} onChange={(v) => onChange({ ctaUrl: v })} />

      <h3 style={{ fontSize: 14, fontWeight: 800, margin: '24px 0 10px' }}>Avantages</h3>
      <ListEditor<FeatureItem>
        items={data.features}
        onChange={(features) => onChange({ features })}
        itemLabel="un avantage"
        newItem={() => ({ icon: 'check', text: 'Nouvel avantage' })}
        renderItem={(f, patch) => (
          <>
            <TextField label="Texte" value={f.text} onChange={(v) => patch({ text: v })} />
            <SelectField label="Icône" value={f.icon} onChange={(v) => patch({ icon: v })} options={ICON_NAMES.map((n) => ({ value: n, label: n }))} />
          </>
        )}
      />
    </div>
  );
}
